import styled from 'styled-components';
import NameChangeWrongSvg from '../../assets/mytrips/name-change-wrong.svg';

const NameChangeWrongIcon = styled(NameChangeWrongSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '21rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default NameChangeWrongIcon;
